import { render, staticRenderFns } from "./BasePageRefine.vue?vue&type=template&id=417af65b&"
import script from "./BasePageRefine.vue?vue&type=script&lang=js&"
export * from "./BasePageRefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports